import * as Yup from 'yup'

const UrlRewriteFormSchema = Yup.object().shape({
  old_path: Yup.string()
    .required('Required'),
  new_path: Yup.string()
    .required('Required')
})

export default UrlRewriteFormSchema
